var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('app-progress'),_c('header',[_vm._v("Resetting")]),_c('main',[_c('router-view')],1),_c('footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }